import React from 'react'
import { RADOM_COLORS } from '../../../util/Constants'
interface ISummaryRowProps {
  title: string
  value: string
}

const SummaryRow = ({ title, value }: ISummaryRowProps): JSX.Element => {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10 }}><span style={{ fontSize: 16 }}>{title}</span><span style={{
      color: RADOM_COLORS.RADOM_BLUE, fontSize: 16, fontWeight: 500
    }}>{value}</span></div>)
}

export default SummaryRow
